var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "tab-header sub-menu-header d-lg-none d-flex justify-content-between align-items-center",
        },
        [
          _c(
            "button",
            {
              staticClass: "close-tab d-flex align-items-center cursor-pointer",
              attrs: { type: "button", "aria-label": "Close Tab" },
              on: { click: _vm.closeTab },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M15.8334 10H4.16669M4.16669 10L10 15.8334M4.16669 10L10 4.16669",
                      stroke: "#363636",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("h4", [
            _vm._v(
              "\n      " + _vm._s(_vm.multiLanguage.OrientRugs) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close-tab d-flex align-items-center cursor-pointer",
              attrs: { type: "button", "aria-label": "Close Navigation" },
              on: {
                click: function ($event) {
                  return _vm.closeNavigation()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M15 5L5 15M5 5L15 15",
                      stroke: "#363636",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm._t("main-oriental-content"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }